import { ApplicantStatusesEnum } from '@thinknet-gmbh/platform-common';
import {
  Button,
  ButtonsWrapper,
  Form,
  Modal,
  SelectInput,
} from '@thinknet-gmbh/platform-common-ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useSendApplicantEmailTemplate } from 'src/hooks/applicants/send-applicant-email-template.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useGetEmailTemplatesForList } from 'src/hooks/email-templates/get-email-templates.hook';

interface IProps {
  isOpened: boolean;
  onClose: () => void;
  applicantId: string;
  title: string;
  status: ApplicantStatusesEnum;
}

const EmailTemplateSelectModal: FC<IProps> = ({
  isOpened,
  onClose,
  applicantId,
  title,
  status,
}) => {
  const { t } = useTranslation(['common']);
  const companyId = useGetCurrentCompanyId();
  const { emailTemplates, loading } = useGetEmailTemplatesForList(companyId);
  const { sendEmailTemplate } = useSendApplicantEmailTemplate({ onSuccess: onClose });

  const onFinish = ({ emailTemplateId }: any) => {
    sendEmailTemplate({
      variables: {
        emailTemplateId,
        applicantId,
        status,
      },
    });
  };

  return (
    <Modal isOpened={isOpened} onClose={onClose} title={title}>
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="emailTemplateId"
          label={t('settings:permissionGroupSettings.yuuHrPermissions.emailTemplates')}
          rules={[{ required: true, message: t('common:validation.error.fieldRequired') }]}
        >
          <SelectInput placeholder={t('common:placeholders.selectFromList')}>
            {emailTemplates.map(({ _id, subject }: any) => (
              <SelectInput.Option value={_id} key={_id}>
                {subject}
              </SelectInput.Option>
            ))}
          </SelectInput>
        </Form.Item>

        <ButtonsWrapper marginTop={16}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('common:buttons.send')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};

export default EmailTemplateSelectModal;
